<template>
  <div v-if="show">
    <collapse-transition>
      <div v-if="isMessageShow" class="cookie-msg">
        <div class="cookie-msg__text">{{$tCookie('message')}}</div>
        <div class="cookie-msg__btn">
          <button @click.prevent="closeMsg" type="button" class="base-btn base-btn--green base-btn--small">
            <span class="base-btn__text">{{$tGlobal('Ok')}}</span>
          </button>
        </div>
      </div>
    </collapse-transition>

  </div>
</template>

<script>
  import {CollapseTransition} from "vue2-transitions";

  export default {
    name: "CookieMsg",
    components: {
      CollapseTransition
    },
    data() {
      return {
        isMessageShow: true
      }
    },
    computed: {
      show() {
        return !isRobotAgent
      }
    },
    methods: {
      closeMsg() {
        this.isMessageShow = false
        localStorage.setItem('cookieAccepted', true)

      }
    },
    created() {
      if (localStorage.getItem('cookieAccepted')) {
        this.isMessageShow = false
      }
    }

  }
</script>

<style scoped>

</style>
